import { defineObstacle } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   ÉCLAT — le petit astéroïde, celui qu'on fait sauter au passage.

   30 PV : trois volées de VULCAN (200 DPS nominal) le brisent en ~0,15 s. Il
   n'est pas un mur, il est un grain que le tir automatique nettoie tout seul
   quand on le survole — sa fonction est de MEUBLER un champ, de donner à esquiver
   entre deux gros blocs sans jamais bloquer une ligne à lui seul.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineObstacle({
  id: 'astero-eclat',
  radius: 24,
  hp: 30,
  destructible: true,
  score: 20,
});
